import { Card, Col, Form, Input, InputNumber, Row, Select, Switch, Typography } from 'antd';
import { SettingsHeader } from '@/components/settings';

const { Title } = Typography;

const Settings = () => {
  const handleResetDefaults = () => {
    console.info('Reset platform settings to defaults');
  };

  const handleSaveChanges = () => {
    console.info('Save platform settings');
  };

  return (
    <div className='space-y-6'>
      <SettingsHeader onResetDefaults={handleResetDefaults} onSaveChanges={handleSaveChanges} />

      <Title level={5} className='!mt-2'>AI Health Scanning</Title>
      <Card className='admin-card'>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label='Vision Model'>
              <Select defaultValue='gemini-1.5-pro'>
                <Select.Option value='gemini-1.5-pro'>Gemini 1.5 Pro</Select.Option>
                <Select.Option value='gemini-1.5-flash'>Gemini 1.5 Flash</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label='Daily Free Scan Limit'>
              <InputNumber min={1} defaultValue={3} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label='Pro Unlimited'>
              <Switch defaultChecked />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item label='System Prompt (skin)'>
          <Input.TextArea rows={2} defaultValue='Analyze pet skin photo for common conditions. Be concise. Output JSON: condition, confidence, advice.' />
        </Form.Item>
      </Card>

      <Title level={5}>Pro Tier Pricing</Title>
      <Card className='admin-card'>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item label='Monthly Price (USD)'>
              <InputNumber min={0} defaultValue={4.99} step={0.01} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label='Annual Price (USD)'>
              <InputNumber min={0} defaultValue={49} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label='Features'>
              <Select mode='tags' defaultValue={['unlimited_scans','pdf_reports','trend_alerts','advanced_weight']}>
                <Select.Option value='unlimited_scans'>Unlimited Scans</Select.Option>
                <Select.Option value='pdf_reports'>Vet PDF Reports</Select.Option>
                <Select.Option value='trend_alerts'>Trend Push Alerts</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Card>

      <Title level={5}>Notifications</Title>
      <Card className='admin-card'>
        <Row gutter={16}>
          <Col span={8}><Form.Item label='Daily Health Reminder'><Switch defaultChecked /></Form.Item></Col>
          <Col span={8}><Form.Item label='Weight Trend Alerts'><Switch defaultChecked /></Form.Item></Col>
          <Col span={8}><Form.Item label='AI Scan Ready'><Switch defaultChecked /></Form.Item></Col>
        </Row>
        <Form.Item label='Support Email'>
          <Input defaultValue='support@borzi.app' />
        </Form.Item>
      </Card>

      <Title level={5}>Content Moderation</Title>
      <Card className='admin-card'>
        <Row gutter={16}>
          <Col span={8}><Form.Item label='Auto-approve Resources'><Switch /></Form.Item></Col>
          <Col span={8}><Form.Item label='Flag Toxic Comments'><Switch defaultChecked /></Form.Item></Col>
          <Col span={8}><Form.Item label='Max Reports Before Hide'><InputNumber defaultValue={3} /></Form.Item></Col>
        </Row>
        <Form.Item label='Banned Keywords (comma sep)'>
          <Input defaultValue='harm,poison,illegal' />
        </Form.Item>
      </Card>
    </div>
  );
};

export { Settings };
export default Settings;
